import React, { useEffect, useState } from 'react'
import { Container, Grid, makeStyles, Paper, Typography } from '@material-ui/core'

import Panel from '../component/um/external-researcher/Panel'
import Result from '../component/um/external-researcher/Result'
import useExternalResearcher, { ResponseT, SearchFormT } from '../services/um/useExternalResearcher'
import SearchAccordion from '../control/accordion/SearchAccordion'
import useTranslate from '../i18n/useTranslate'
import { useHistory } from 'react-router-dom'
import { useQueryParam, StringParam, ArrayParam } from 'use-query-params'
import { FormApi } from 'final-form'
import { encryptionAES } from '../utilities/encryption'
import useLoading from '../control/loading/useLoading'

const ExternalResearcher = () => {
    const translate = useTranslate()
    const history = useHistory()
    const { get } = useExternalResearcher()
    const classes = useStyles()
    const loadingHook = useLoading()
    const [keyword, setKeyword] = useQueryParam('keyword', StringParam)
    const [statusID, setStatusID] = useQueryParam('statusID', ArrayParam)
    const [isExpanded, setIsExpanded] = useState<boolean>(true)

    const [data, setData] = useState<ResponseT[]>([])

    const [initialSearch, setInitialSearch] = useState({
        keyword: keyword ?? '',
        statusID: (statusID as string[]) ?? ['1'],
    })

    useEffect(() => {
        onSearch(initialSearch)
    }, [])

    const onSearch = async (values: SearchFormT) => {
        loadingHook.loadingOpen()
        const result = await get({ keyword: values.keyword || '', statusID: values.statusID || ['1'] })
        loadingHook.loadingClose()
        setKeyword(values.keyword || '')
        setStatusID(values.statusID || ['1'])
        setData(result.result)
    }

    const onEdit = (userID: string) => {
        history.push(`/external-researcher/${encryptionAES(userID)}/approve`)
    }

    const onReset = (form: FormApi<SearchFormT, Partial<SearchFormT>>) => {
        let param = {
            keyword: '',
            statusID: ['1'],
        }
        form.initialize(param)
        setInitialSearch(param)
        onSearch(param)
    }

    const handleEnter = (values: SearchFormT) => {
        onSearch(values)
    }
    return (
        <Container maxWidth="lg">
            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <SearchAccordion title={translate.get('UM.EXTERNAL-RESEARCHER.MENU')}>
                        <Panel
                            onSubmit={onSearch}
                            initialSearch={initialSearch}
                            onReset={onReset}
                            onEnter={handleEnter}
                        />
                    </SearchAccordion>
                </Grid>
                <Grid item xs={12}>
                    <Result data={data} onClickEdit={onEdit} />
                </Grid>
            </Grid>
        </Container>
    )
}

export default ExternalResearcher
const useStyles = makeStyles((theme) => ({
    paperFromSearch: {
        width: '100%',
        padding: '30px',
        marginBottom: '10px',
    },
}))
